module.exports = __webpack_public_path__ + "static/dimm1-f513eebf25a03f48cb4f83b18da5a602.mp4";